import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../api";

export default function Dashboard() {

  const navigate = useNavigate();

  const [data, setData] = useState({
    users: 0,
    bookings: 0,
    revenue: 0
  });

  const [loading, setLoading] = useState(true);

  /* ===============================
     🔐 GET TOKEN (FIXED)
  =============================== */
  const getToken = () => localStorage.getItem("token");

  /* ===============================
     🔐 AUTH + FETCH (UPDATED)
  =============================== */
  useEffect(() => {

    const token = getToken();

    // 🚫 NO TOKEN → REDIRECT
    if (!token) {
      console.warn("🚫 No token found");
      navigate("/login", { replace: true });
      return;
    }

    // 🔥 OPTIONAL: CHECK TOKEN EXPIRY
    try {
      const payload = JSON.parse(atob(token.split(".")[1]));
      if (payload.exp * 1000 < Date.now()) {
        console.warn("⏰ Token expired");
        localStorage.removeItem("token");
        navigate("/login", { replace: true });
        return;
      }
    } catch {
      console.warn("⚠️ Invalid token");
      localStorage.removeItem("token");
      navigate("/login", { replace: true });
      return;
    }

    const fetchData = async () => {
      try {
        const res = await fetch(`${API}/dashboard`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          }
        });

        const result = await res.json();

        console.log("📊 DASHBOARD:", result);

        if (!res.ok) {
          throw new Error(result.message || "Fetch failed");
        }

        setData({
          users: result.data?.totalUsers || 0,
          bookings: result.data?.bookings || 0,
          revenue: result.data?.revenue || 0
        });

      } catch (err) {
        console.error("❌ Dashboard error:", err);

        // 🔥 FORCE LOGOUT IF TOKEN BAD
        localStorage.removeItem("token");

        navigate("/login", { replace: true });
      } finally {
        setLoading(false);
      }
    };

    fetchData();

  }, [navigate]);

  return (
    <div className="space-y-6">

      {/* HEADER */}
      <div>
        <h2 className="text-3xl font-bold mb-2">Dashboard</h2>
        <p className="text-gray-500">
          Welcome back! Here's what's happening in your system.
        </p>
      </div>

      {/* KPI CARDS */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">

        <div className="bg-white p-6 rounded-xl shadow-sm border">
          <h4 className="text-sm text-gray-500">Total Users</h4>
          <p className="text-2xl font-bold mt-2">
            {loading ? "..." : data.users}
          </p>
        </div>

        <div className="bg-white p-6 rounded-xl shadow-sm border">
          <h4 className="text-sm text-gray-500">Bookings</h4>
          <p className="text-2xl font-bold mt-2">
            {loading ? "..." : data.bookings}
          </p>
        </div>

        <div className="bg-white p-6 rounded-xl shadow-sm border">
          <h4 className="text-sm text-gray-500">Revenue</h4>
          <p className="text-2xl font-bold mt-2 text-green-600">
            {loading ? "..." : `₱${data.revenue}`}
          </p>
        </div>

        <div className="bg-white p-6 rounded-xl shadow-sm border">
          <h4 className="text-sm text-gray-500">Growth</h4>
          <p className="text-2xl font-bold mt-2 text-green-600">
            +12%
          </p>
        </div>

      </div>

      {/* MAIN GRID */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">

        {/* LEFT */}
        <div className="lg:col-span-2 space-y-6">

          <div className="bg-white p-6 rounded-xl shadow-sm border">
            <h3 className="text-lg font-semibold mb-4">
              Recent Activity
            </h3>

            <ul className="space-y-3 text-sm text-gray-600">
              <li>✔ New user registered</li>
              <li>✔ Booking created</li>
              <li>✔ Payment completed</li>
              <li>✔ New inquiry received</li>
            </ul>
          </div>

          <div className="bg-white p-6 rounded-xl shadow-sm border">
            <h3 className="text-lg font-semibold mb-4">
              Performance Overview
            </h3>

            <div className="h-48 flex items-center justify-center text-gray-400">
              Chart coming soon...
            </div>
          </div>

        </div>

        {/* RIGHT */}
        <div className="space-y-6">

          <div className="bg-white p-6 rounded-xl shadow-sm border">
            <h3 className="text-lg font-semibold mb-4">
              Quick Actions
            </h3>

            <div className="flex flex-col gap-3">
              <button className="bg-green-600 text-white py-2 rounded-lg">
                Add User
              </button>
              <button className="bg-blue-600 text-white py-2 rounded-lg">
                Create Report
              </button>
              <button className="bg-yellow-500 text-white py-2 rounded-lg">
                View Analytics
              </button>
            </div>
          </div>

          <div className="bg-white p-6 rounded-xl shadow-sm border">
            <h3 className="text-lg font-semibold mb-4">
              Notifications
            </h3>

            <ul className="space-y-2 text-sm text-gray-600">
              <li>🔔 3 new messages</li>
              <li>📊 Report ready</li>
              <li>⚡ System update completed</li>
            </ul>
          </div>

        </div>

      </div>

    </div>
  );
}